import {RootState} from "../store";
import {createSelector} from "reselect";

export const getIsAuth = (state: RootState) => {
    return state.authReducer.isAuth
}

export const getUser = (state: RootState) => {
    return state.authReducer.profile
}

export const getIsAuthLoading = (state: RootState) => {
    return state.authReducer.isLoading
}

export const getIsCompletelyFilledDataUser = createSelector(getUser, (user) => {
    return !!user?.firstName && !!user?.secondName && !!user.lastName && !!user?.organization && !!user.phone
})